<template>
  <GraphQLToastBridge />
  <router-view />
</template>

<script setup lang="ts">
import GraphQLToastBridge from "@/components/GraphQLToastBridge.vue"
</script>
